export const PRIMARY_COLOR = '#d39340';
export const LAYOUT_BACKGROUND_COLOR = '#ffffff';
